import React, { useState } from "react";
import { BundlePackageData } from "../../interfaces/BundlePackageGroup";
import { textFormatter } from "../comboPackageGroup/ComboPackageGroup";
import styles from "./BundlePackageGroup.module.css";
import useComponentsStore from "../../store/componentsStateStore";
import {
  getGeneralImage,
  myListingRedirect,
  generateStyleClasses,
} from "../../helpers/commonFunctions";
import Swal from "sweetalert2";
import useAppStore from "../../store/AppStore";
import {
  logBoostListingBundle,
} from "../../membership/logging/helpers/commonLoggingFunctions";

export default function BundlePackageGroup({
  data,
}: {
  data: BundlePackageData;
}) {
  const dashedSeparator = data?.dashedSeparator;
  const title = data?.title;
  const subtitle = data?.subtitle;
  const footer = data?.footer;
  const featuresList = data?.featuresList;
  const actionButton = footer?.actionButton;
  const { continueDraft } = useComponentsStore();
  const [isLoading, setIsLoading] = useState(false);

  const { handleToastTrigger, language } = useAppStore();
  const onClickHandler = async () => {
    const confirmationButtons = {
      yes: {
        ar: "نعم",
        en: "Yes",
      },
      no: {
        ar: "لا",
        en: "No",
      },
    };

    if (!actionButton?.confirmation) activeBundlePackageGroup();
    else {
      Swal.fire({
        text: actionButton?.confirmation,
        showCancelButton: true,
        confirmButtonText: confirmationButtons.yes[language],
        confirmButtonColor: "#3085d6",
        cancelButtonText: confirmationButtons.no[language],
        cancelButtonColor: "#3085d6",
      }).then(async (result) => {
        if (result.isConfirmed) {
          activeBundlePackageGroup();
        }
      });
    }
  };

  async function activeBundlePackageGroup() {
    const bundleMessages = {
      success: {
        ar: "تم تفعيل الباقة بنجاح",
        en: "Bundle activated successfully",
      },
      error: {
        ar: "حدث خطأ ما",
        en: "Something went wrong",
      },
    };
    try {
      setIsLoading(true);
      logBoostListingBundle(actionButton.payload.cartId);
      await continueDraft(actionButton.payload, true);
      handleToastTrigger({
        toastType: "success",
        locale: language,
        description: bundleMessages.success[language],
        autoClose: 2000,
      });
      setTimeout(() => {
        myListingRedirect();
      }, 2000);

      setIsLoading(false);
    } catch (err) {
      handleToastTrigger({
        toastType: "error",
        locale: language,
        description: bundleMessages.error[language],
        autoClose: 2000,
      });
      setIsLoading(false);
    }
  }

  return (
    <div
      className={`vas-border vas-border-2 vas-d-flex vas-flex-column vas-gap-2 vas-p-3 vas-border-radius vas-mb-2 vas-mt-4 ${styles.bundle_card}`}
    >
      <div>
        <p
          className={`vas-fs-6 vas-fw-bold ${generateStyleClasses(title?.style)}`}
          style={{ color: title?.textColor }}
        >
          {title?.text ?? ""}
        </p>
        <p
          className={`vas-fs-6 vas-mb-0 ${generateStyleClasses(subtitle?.style)}`}
          style={{ color: subtitle?.textColor }}
        >
          {subtitle?.text ?? ""}
        </p>
      </div>
      <span
        className={`vas-dotted-line vas-my-2`}
        style={{ borderColor: dashedSeparator?.color }}
      />
      <div className="vas-pt-2">
        {textFormatter(footer?.unitPrice?.text, "vas-fs-7") ?? ""}
      </div>
      <span
        className={`vas-dotted-line vas-my-2`}
        style={{ borderColor: dashedSeparator?.color }}
      />
      <div className="vas-pt-2 mb-2 vas-fs-7">
        {featuresList &&
          featuresList.map((feature, index) => (
            <React.Fragment key={index}>
              <img
                className="vas"
                src={getGeneralImage(feature?.icon)}
                alt="check_icon"
                width={20}
                height={18}
              />
              <span style={{ color: feature?.textColor }}>
                {feature?.text ?? ""}
              </span>
            </React.Fragment>
          ))}
      </div>
      <button
        className={`vas-btn vas-btn-lg vas-w-100 vas-mt-2 vas-fw-bold vas-fs-7 vas-border-radius`}
        style={{
          color: actionButton?.textColor,
          backgroundColor: actionButton?.backgroundColor,
          borderColor: actionButton?.border_color,
        }}
        onClick={onClickHandler}
      >
        {isLoading ? (
          <i className="vas-spinner-border vas-spinner-border-sm vas-p-2" />
        ) : (
          <>{actionButton?.text}</>
        )}
      </button>
    </div>
  );
}
